import {AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {Subscription, timer} from 'rxjs';
import {User} from '../../Interfaces/User';
import {AppComponent} from '../../app.component';
import {QueryService} from '../../Services/query.service';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {GateTransactionDetailsView} from '../../Interfaces/GateTransactionDetailsView';
import {Router} from '@angular/router';
import {GateDamages} from '../../Interfaces/GateDamages';
import {PortExclusions} from '../../Interfaces/PortExclusions';
import {GateError} from '../../Interfaces/GateError';
import {GateTransactionStages} from '../../Interfaces/GateTransactionStages';
import {Visit} from '../../Interfaces/Visit';
import {TruckerVisitErrors} from '../../Interfaces/TruckerVisitErrors';

@Component({
  selector: 'app-driver-homepage',
  templateUrl: './driver-homepage.component.html',
  styleUrls: ['./driver-homepage.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DriverHomepageComponent implements OnInit, OnDestroy, AfterViewInit {


  public slots : {lane: string}[] = [];
  public containers : {container: string, inOrOut: string}[] = [];
  public flatRacks : {container: string, inOrOut: string}[] = [];
  public transactions : {container: string, length: string, pos: string, type: string}[] = [];
  areaOut: string = "";
  bcFormat: string = "CODE128";
  bcHeight: string = "50";
  visitNumber: string = "";
  tempReq: string = "";
  next_stage_desc: string = "";
  next_stage_id: string = "";
  next_stage_order: number = 0;
  receiveCount: number = 0;   deliverCount: number = 0; receiveHeap: number = 0; deliverHeap: number = 0;receiveSlotCount = 0; deliverSlotCount=0;  deliverYardCompletedCount: number = 0;   receiveYardCompletedCount: number = 0;

  driver_card_id: string = "";
  truckingCo: string = "";
  gotoMessage: string="";
  secondLine: string="";
  secondLineNAHalf: string="";
  secondLineNAHalf2: string="";
  secondLineNAHalf3: string="";
  thirdLine: string="";
  fourthLine: string="";
  fourthLinePreText: string="";
  firstLinePreText: string="Go to ";
  truckVisitStatus: string="";
  rpmStatus: string="";
  firstIncompleteStage: string="";
  canceledRec: boolean = false;
  badSlotError: boolean = false;
  noRecord: boolean = false;
  isRFIDError: boolean = false;
  returnStatus: boolean = true;
  rpmFound: boolean = false;
  private  myUser: User;
  inboundOutboundDamages: string = "R";
  damageArray: GateDamages[];
  damageObj: GateDamages;

  damageArrayMaster: GateDamages[];
  portExclusions: PortExclusions[];
  gateErrors: GateError[];
  gateErrorObj: GateError;
  portSSLs: string;
  subscription2: Subscription;

  private clientRequest: ClientRequest;
  private subscription: Subscription;
  private subscription3: Promise<void>;
  private gateTrans: GateTransactionDetailsView[];
  private truckVisitErrors: TruckerVisitErrors[];
   gateTransStagesArray: GateTransactionStages[];
   gateTransStages: GateTransactionStages;
    stagesForDisplay: GateTransactionStages[];
  visitObj: Visit;
  constructor(private myApp:AppComponent, private  queryService: QueryService, private  globalEventsManager: GlobalEventsManager, private router: Router) {
    this.myUser = this.myApp.user;

/*
    this.myUser = {} as User;
    this.myUser.active ="Y"
    this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
    this.myUser.address_2 = null
    this.myUser.company_code ="M0995"
    //this.myUser.company_code ="EGN"
    this.myUser.company_name= "MAHER TERMINALS, LLC"
    this.myUser.city= "HOUSTON"
    this.myUser.email_address= null
    this.myUser.fax_number= null
    this.myUser.first_name= "Csp Craig"
    this.myUser.last_name= "Miller"
    this.myUser. maherError= null
    this.myUser.old_password= null
    this.myUser.password= ""
    this.myUser.phone_number= null
    this.myUser.company_scac= null
    this.myUser.state= "TX"
    this.myUser.userMenuReportItemsView= null
    this.myUser.user_gkey= "802007"
     this.myUser.role= "AGENT"
   // this.myUser.role= "LINEOP"
   // this.myUser.role= "HAULIER"
    this.myUser.username="CSPDRIVERLUCY";
    this.myUser.zip="07201"
    this.myUser.canSeeAllData = "1";



 */




  }

  ngOnDestroy() {
    if (this.subscription2!=null){
      this.subscription2.unsubscribe();
    }
  }

  ngOnInit() {
    this.getVisitByUsername();
  }

  ngAfterViewInit(): void {

    this.subscription2 = timer(12000, 12000).subscribe(t => {
      this.getVisitByUsername();
    });



  }

  async getVisitByUsername(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    if (this.myUser==undefined){
      this.myUser = {} as User;
      this.myUser.username = localStorage.getItem("user");
      this.clientRequest.user = this.myUser;
    }else{
      this.clientRequest.user = this.myUser;
    }
    this.clientRequest.requestData = [];
    const lhsUserObs$ = this.queryService.getVisitByUsername(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.gateTrans = lstConts;
        if (this.gateTrans!=null){
          for (var items of this.gateTrans){
            if (items.ctr_pos_slot!=null && items.ctr_pos_slot!=""){
              items.ctr_pos_slot = items.ctr_pos_slot.substring(items.ctr_pos_slot.lastIndexOf("-")+1);
            }
          }
        }
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      async () => {
        this.noRecord = false;
        this.secondLine = "";
        this.secondLineNAHalf = "";
        this.secondLineNAHalf2 = "";
        this.secondLineNAHalf3 = "";
        this.thirdLine = "";
        this.fourthLine = "";
        this.fourthLinePreText = "";
        if (this.gateTrans != null && (this.gateTrans[0].maherError != null && this.gateTrans[0].maherError.toUpperCase() == "NO RECORDS FOUND")) {
          this.noRecord = true;
        } else {
            this.fillScreenFromGate();
            if (!this.canceledRec) {
              this.fillMiddlePanelFromNextStage();

            }
          }





      });

  }

  fillScreenFromGate(){

    this.gotoMessage = ""
    this.firstLinePreText = "Go to ";
    this.secondLine = ""
    this.secondLineNAHalf="";
    this.secondLineNAHalf2="";
    this.secondLineNAHalf3="";
    this.thirdLine = "";
      this.canceledRec = false;
      this.receiveCount = 0;
      this.receiveSlotCount = 0;
      this.receiveYardCompletedCount = 0;
      this.deliverCount = 0;
      this.deliverSlotCount = 0;
      this.receiveHeap = 0;
      this.deliverHeap = 0;
      this.deliverYardCompletedCount = 0;
      this.rpmFound = false;
      this.rpmStatus = "";
      this.damageArrayMaster = [];
      this.slots = [];
      this.gateErrors = [];
      this.damageArray = [];
      this.containers = [];
      this.transactions = [];
      this.portExclusions = [];

      if (this.gateTrans!=null && this.gateTrans.length>0){

            this.gateTrans.forEach(dd => {
              this.truckVisitStatus = dd.truck_visit_status;

              if (dd.driver_card_id != undefined && dd.driver_card_id != "") {
                this.driver_card_id = dd.driver_card_id;
              } else {
                this.driver_card_id = "";
              }
              if (dd.trucking_company_description != undefined && dd.trucking_company_description != "") {
                this.truckingCo = dd.trucking_company_description;
              } else {
                this.truckingCo = "";
              }
              if (dd.gate_description != undefined && dd.gate_description != "") {
                this.areaOut = dd.gate_description;
              } else {
                this.areaOut = "";
              }
              if (dd.visit != undefined && dd.visit != "") {
                this.visitNumber = dd.visit;
              } else {
                this.visitNumber = "";
              }

              dd.showLines = true;



              if (dd.truck_visit_status=="CANCEL"){
                if (dd.transaction_type==null || dd.transaction_status=="CANCEL"){
                  dd.showLines = true;
                }

                this.canceledRec = true;
                this.fourthLine = "VOIDED";
                this.fourthLinePreText = "Status: ";
                this.gotoMessage = "Void Out Security Lane"
                this.gateErrors = []
                if (dd.gateErrors != null && dd.gateErrors.length > 0) {
                  dd.gateErrors.forEach(xx => {
                    this.gateErrors.push(xx);
                  })
                }

                if (dd.bat_nbr == "RFID"){
                  this.isRFIDError = true;
                  this.secondLine = dd.rfid_status_reason;
                  this.thirdLine = "A valid PortTruckPass Tag is mandatory for terminal entry. For PortTruckPass inquiries, please call customer support at 866-758-3838";
                }else{
                  this.isRFIDError = false;
                  this.secondLine = dd.cancel_reason_description;
                  this.thirdLine = "";
                }
              }else {

                if (dd.next_stage_order=="8" && dd.truck_visit_status=="OK") {
                  this.canceledRec = true;
                  this.firstLinePreText = "";
                  this.gotoMessage = "In Progress...";
                }else if (dd.transaction_status=="CANCEL"){
                    dd.showLines = false;
                }else{
                    dd.stayInSlot = false;
                  if (this.slots.findIndex(ff => ff.lane==dd.slot)==-1){
                      this.slots.push({"lane": dd.slot});
                    }else{
                      dd.stayInSlot = true;
                  }

                  if (dd.gateDamages != null && dd.gateDamages.length > 0) {
                    dd.gateDamages.forEach(xx => {
                      xx.inOrOut = dd.transaction_type.substring(0, 1);
                      xx.container = dd.container;
                      this.damageArrayMaster.push(xx);
                    })
                  }else{
                    this.damageObj = {} as GateDamages;
                    this.damageObj.inOrOut = dd.transaction_type.substring(0, 1);
                    this.damageObj.container = dd.container;
                    this.damageObj.damage_component = "No Damages";
                    this.damageArrayMaster.push(this.damageObj);
                  }


                  if (dd.container!=null && dd.transaction_type!=null){
                    this.containers.push({"container": dd.container, "inOrOut": dd.transaction_type.substring(0,1)});
                  }

                  if (dd.transaction_type!=null){
                    if (dd.transaction_type.substring(0, 1) == "R") {
                      this.receiveCount++;
                      if (dd.exchange_area_id==null || dd.ctr_pos_slot.substring(0,1)=="G"){
                        this.receiveHeap++
                        this.transactions.push({"container": dd.container, "length": dd.ctr_length, "pos": this.fixGroundedLocation(dd.ctr_pos_slot), "type": dd.transaction_type});

                      }
                      if (dd.slot!=null) {
                        this.receiveSlotCount++;
                        if (dd.yard_completed!=null) {
                          this.receiveYardCompletedCount++
                        }
                      }
                    }else {
                      this.deliverCount++;
                      if (dd.exchange_area_id==null){
                        this.deliverHeap++
                        this.transactions.push({"container": dd.container, "length": dd.ctr_length, "pos": this.fixGroundedLocation(dd.ctr_pos_slot), "type": dd.transaction_type});
                      }
                      if (dd.slot != null) {
                        this.deliverSlotCount++;
                        if (dd.yard_completed != null) {
                          this.deliverYardCompletedCount++
                        }
                      }
                    }
                  }



                  if (((Number.parseInt(dd.next_stage_order) > 55) || (Number.parseInt(dd.next_stage_order) > 54 && dd.gate_description.toUpperCase() == 'EMPTY DEPOT') || (this.truckVisitStatus=="COMPLETE" || this.truckVisitStatus=="CLOSED")) && this.deliverCount > 0)  {
                    this.switchToInOut("D")
                  } else {
                    this.switchToInOut("R")
                  }
                  this.portSSLs = ""
                  if (dd.portExclusions != null && dd.portExclusions.length > 0) {
                    dd.portExclusions.forEach(xx => {
                      if (this.portSSLs == "") {
                        this.portSSLs = dd.line_id;
                      } else {
                        this.portSSLs = this.portSSLs + "," + dd.line_id;
                      }
                      this.portExclusions.push(xx);
                    })
                  }
                  if (dd.next_stage_desc != undefined && dd.next_stage_desc != "") {
                    this.next_stage_desc = dd.next_stage_desc;
                    this.next_stage_order = Number.parseInt(dd.next_stage_order);
                    this.next_stage_id = dd.next_stage_id;
                  }

                  if (dd.transaction_type!=null){
                    if (dd.transaction_type.substring(0, 1) == "D") {
                      if (dd.rpm_alarm_date != null) {
                        this.rpmFound = true;
                        if (dd.rpm_inspection_date == null) {
                          this.rpmStatus = "INCOMPLETE"
                        } else {
                          this.rpmStatus = "COMPLETE";
                        }
                      }
                    }
                  }



                  this.gateErrors = [];

                  if (dd.truck_visit_status != "OK") {
                    if (dd.gateErrors != null && dd.gateErrors.length > 0) {
                      dd.gateErrors.forEach(xx => {
                        this.gateErrors.push(xx);
                      })
                    }
                  }
                }
              }
              }
            )
      }
  }


  switchToInOut(fromWhere: string){
    this.inboundOutboundDamages = fromWhere;
    if (fromWhere=="R"){
      this.damageArray = this.damageArrayMaster.filter(xx => xx.inOrOut=="R");
    }else{
      this.damageArray = this.damageArrayMaster.filter(xx => xx.inOrOut=="D");
    }
  }




  async  getGateStagesByVisit(): Promise<boolean>{
    this.returnStatus = true;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;

    if (this.myUser==undefined){
      this.myUser = {} as User;
      this.myUser.username = localStorage.getItem("user");
      this.clientRequest.user = this.myUser;
    }else{
      this.clientRequest.user = this.myUser;
    }

    this.gateTransStagesArray = [];
    this.stagesForDisplay = [];
    this.gateTransStages = {} as GateTransactionStages;
    this.gateTransStages.visit = this.visitNumber;
    this.gateTransStagesArray.push(this.gateTransStages);
    this.clientRequest.requestData = this.gateTransStagesArray;
    const lhsUserObs$ = this.queryService.getGateStagesByVisit(this.clientRequest);
    // @ts-ignore
    this.subscription3 = await lhsUserObs$.then(
      (lstConts) => {
        this.visitObj = lstConts;
        this.noRecord = false;


        if (this.visitObj!=null && this.visitObj.gateTransactionStages.length>0){
          var alreadyAdded = false, ignoreReceives = false;
          this.firstIncompleteStage = "";
          this.visitObj.gateTransactionStages.forEach(xx => {
            if (Number.parseInt(xx.stage_order)>45 && this.rpmFound && !alreadyAdded){
              this.gateTransStages = {} as GateTransactionStages;
              this.gateTransStages.stage_order ="73";
              this.gateTransStages.stage_desc = "Customs RPM";
              this.gateTransStages.stage_status = this.rpmStatus;
              this.stagesForDisplay.push(this.gateTransStages);
              alreadyAdded = true;
            }



            if (this.stagesForDisplay.findIndex(pp => pp.stage_order == xx.stage_order)==-1){
              if (this.visitObj.visitStages!=null && this.visitObj.visitStages.length>0){
                var indx = this.visitObj.visitStages.findIndex(gg => gg.tv_stage_id == xx.stage_id && gg.tv_stage_id.toUpperCase()!="YARD");
                if (indx!=-1){
                  xx.stage_status = this.visitObj.visitStages[indx].tv_stage_status;
                }

                if (xx.stage_desc.toUpperCase()=="INLANES" ){
                   if (xx.stage_status.toUpperCase()=="TROUBLE" && this.truckVisitStatus=="OK"){
                        xx.stage_status = "COMPLETE";
                   }
                }


                if (xx.stage_desc.toUpperCase()=="YARD" ){
                      if (this.receiveCount>0 && this.receiveSlotCount>0){ //we had receives that went to slot
                        xx.stage_desc =  "Straddle Received";
                        if (this.receiveSlotCount!=this.receiveYardCompletedCount){ //all receives going to slot were yard completed - show complete on screen
                          xx.stage_status = "INCOMPLETE";
                        }
                        this.stagesForDisplay.push(xx);
                      }

                      if (this.deliverCount>0 && this.deliverSlotCount>0) { //we had delivers that went to slot
                          this.gateTransStages = {} as GateTransactionStages;
                          this.gateTransStages.stage_order ="42";
                          this.gateTransStages.stage_desc = "Straddle Delivered";
                          if (this.deliverSlotCount != this.deliverYardCompletedCount) { //all delivers going to slot were yard completed - show complete on screen
                            this.gateTransStages.stage_status = "INCOMPLETE";
                          }else{
                            this.gateTransStages.stage_status = "COMPLETE";
                          }
                          this.stagesForDisplay.push(this.gateTransStages);
                      }
                }else{
                  if (this.firstIncompleteStage=="" && xx.stage_status=="INCOMPLETE"){
                    this.firstIncompleteStage = xx.stage_desc;
                  }
                  this.stagesForDisplay.push(xx);
                }
              }

            }
          })
        }else{
          if (this.visitObj!=null && this.visitObj.visitStages.length>0){
              this.visitObj.visitStages.forEach(xx => {
              this.gateTransStages = {} as GateTransactionStages;
              this.gateTransStages.stage_desc =  xx.tv_stage_id;
              this.gateTransStages.stage_status = xx.tv_stage_status;
              this.stagesForDisplay.push(this.gateTransStages);
            })
            if (this.gateTrans!=null && this.gateTrans.length>0){
              this.gateTrans.forEach(xx=> {
                  xx.showLines = false;
              })
            }
          }

        }

        this.returnStatus = true;

      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
        this.returnStatus = false;
      }
      );
      return this.returnStatus;
  }

  async fillMiddlePanelFromNextStage() {
    this.gotoMessage = ""
    this.firstLinePreText = "Go to ";
    this.secondLine = ""
    this.secondLineNAHalf = "";
    this.secondLineNAHalf2 = "";
    this.secondLineNAHalf3 = "";
    this.thirdLine = "";
    this.fourthLine = "";
    var howMany = 0;



  if (this.truckVisitStatus=="COMPLETE" || this.truckVisitStatus=="CLOSED") {
    this.firstLinePreText = "";
    this.gotoMessage = "Visit Completed"
    return;
  }




    if ((this.next_stage_order < 39 && this.next_stage_order!=8)  || (this.next_stage_order==39 && this.truckVisitStatus=="OK") ) {
      this.gotoMessage = this.next_stage_desc;
      if (this.next_stage_id != null) {
        if (this.next_stage_id.toUpperCase() == "IB_TCIR" || this.next_stage_id.toUpperCase() == "IB_GENSET_LANES") {
          this.gateTrans.forEach(dd => {
            if (dd.transaction_type.substring(0, 1) == "R") {
              if (dd.temp_required_c != null) {
                if (howMany == 0) {
                  this.secondLine = dd.container + " Temp: " + dd.temp_required_c + "C / " + dd.temp_required_f + "F";
                } else {
                  this.thirdLine = dd.container + " Temp: " + dd.temp_required_c + "C / " + dd.temp_required_f + "F";
                }
                howMany++
              }
            }
          })
        }
      }
      return;
    }


    if (this.next_stage_order > 38) {
      if (this.gateTrans.findIndex(xx => xx.transaction_type == "RE" && xx.hazardous == "1" && xx.haz_papers_received == null) != -1) {
        this.gotoMessage = "Clerical Services To Drop Hazmat Papers Off"
        return;
      }
    }

    if (this.next_stage_order > 42) {
      if (this.gateTrans.findIndex(xx => xx.transaction_type.substring(0, 1) == "D" && xx.rpm_alarm_date != null && xx.rpm_inspection_date == null) != -1) {
        this.gotoMessage = "Customs For RPM Inspection"
        return;
      }
    }

    var foundOneForSlotting = false;
    this.badSlotError = true;
    if (this.truckVisitStatus!=null && this.truckVisitStatus== "TROUBLE") {
      if (this.next_stage_id.toUpperCase() == "SLOT_BOOTH") {
        if (this.truckVisitErrors.findIndex(cc => cc.msg_id == "ERROR_JOB_NAME_CONFLICT" && cc.stage_id == "Slot_Booth") >0) {
        }else{
          this.badSlotError = false;
          this.gotoMessage = this.next_stage_id;
        }
      } else {
        this.gotoMessage = "Clerical Services"
        this.badSlotError = false;
        return;
      }
    }



//there is code at the bottom of this component for when empties have a lift date and move away from the 10 min. timer.
    if (this.gateTrans != null && this.gateTrans.length > 0) {
      this.flatRacks = [];
      var transactionNumber=0, previousRec: GateTransactionDetailsView = {} as GateTransactionDetailsView, addedRecord: boolean = false, wasInEmptySection: boolean = false;
      for (var dd of this.gateTrans) {
        if (dd.transaction_status!='CANCEL') {
          transactionNumber++
          if (dd.exchange_area_id != null && (dd.ctr_pos_slot!=null && dd.ctr_pos_slot.substring(0,1)!="G")) {
                  if (dd.yard_completed == null || (dd.strad_status!=null && dd.strad_status.toUpperCase()) == "PENDING") {
                    foundOneForSlotting = true;

                    if (dd.slot != null) {
                      this.gotoMessage = ""
                      this.firstLinePreText = "Go to ";
                      this.secondLine = ""
                      this.secondLineNAHalf = "";
                      this.secondLineNAHalf2 = "";
                      this.secondLineNAHalf3 = "";
                      this.thirdLine = "";
                      this.fourthLine = "";

                      if (dd.stayInSlot) {
                        this.firstLinePreText = "Stay in "
                      }
                      this.gotoMessage = "SLOT " + dd.slot;
                      if (dd.transaction_type.substring(0, 1) == "R") {
                        this.secondLine = "Drop Container " + dd.container;
                      }
                      if (dd.transaction_type.substring(0, 1) == "D") {
                        if (dd.transaction_type == "DI" && dd.group_code != null) {
                          this.secondLine = "Get Container For Group " + dd.group_code;
                        } else {
                          this.secondLine = "Get Container " + dd.container;
                        }
                        this.thirdLine = "This is a " + dd.ctr_length + " container";
                      }
                      this.fourthLinePreText = "Straddle Status: ";
                      this.fourthLine = dd.strad_status;
                    } else {
                      if ((this.receiveHeap>0 || this.deliverHeap>0) && wasInEmptySection){
                        this.thirdLine = "Then go to " +  "<a class='greenFont'>"  + " SLOT BOOTH" + "</a>";
                      }else{
                        this.gotoMessage = "SLOT BOOTH";
                      }

                    }
                    break;
                  }
            } else {
            if ((this.gateTrans[this.gateTrans.length-1].transaction_type=='DI' || this.gateTrans[this.gateTrans.length-1].transaction_type=='DE' || this.gateTrans[this.gateTrans.length-1].transaction_type=='RI' || this.gateTrans[this.gateTrans.length-1].transaction_type=='RE' ) && this.gateTrans[this.gateTrans.length-1].yard_completed!=null){
                       foundOneForSlotting = false;
            }else {


              if (dd.transaction_type == "RM" || dd.transaction_type == "DM") {
                wasInEmptySection = true;
                if (dd.transaction_type == "RM") {
                  if (this.receiveHeap == 1) {//only one receive - business as usual
                    this.gotoMessage = this.fixGroundedLocation(dd.ctr_pos_slot);
                    this.secondLine = "Drop " + dd.container;
                  } else {
                    if (addedRecord && previousRec.ctr_pos_slot == dd.ctr_pos_slot) {// same location?
                      if (this.receiveHeap > 2) { // flat racks
                        var indxPrev = this.flatRacks.findIndex(pp => pp.container != previousRec.container);
                        if (indxPrev == -1) {
                          this.flatRacks.push({
                            "container": previousRec.container,
                            "inOrOut": previousRec.transaction_type.substring(0, 1)
                          });
                        }
                        var indxCur = this.flatRacks.findIndex(pp => pp.container != dd.container);
                        if (indxCur != -1) {
                          this.flatRacks.push({"container": dd.container, "inOrOut": dd.transaction_type.substring(0, 1)});
                        }
                        if (this.flatRacks.length == this.receiveHeap) {
                          this.gotoMessage = this.fixGroundedLocation(dd.ctr_pos_slot);
                          var holdArray = this.flatRacks.filter(ff => ff.inOrOut == "R");
                          var holdLine = "";
                          holdArray.forEach(gg => {
                            holdLine = holdLine + gg.container + ", ";
                          })
                          this.secondLine = "Drop " + holdLine;
                          this.thirdLine = "Proceed To " + "<a class='greenFont'>" + this.firstIncompleteStage.toUpperCase() + "</a>";
                        }
                      } else { //same location ONLY 2 receives
                        this.gotoMessage = this.fixGroundedLocation(dd.ctr_pos_slot);
                        this.secondLine = "Drop " + previousRec.container + " and " + dd.container;
                        this.thirdLine = "Proceed To " + "<a class='greenFont'>" + this.firstIncompleteStage.toUpperCase() + "</a>"; //possibly take this out if DM involved
                      }
                    } else {//diffrerent locations
                      if (addedRecord) {
                        this.gotoMessage = this.fixGroundedLocation(dd.ctr_pos_slot);
                        this.gotoMessage = this.fixGroundedLocation(previousRec.ctr_pos_slot);
                        this.secondLine = "Drop " + previousRec.container;
                        this.secondLineNAHalf = "Then go to " + "<a class='greenFont'>" + this.fixGroundedLocation(dd.ctr_pos_slot) + "</a>" + " and drop " + dd.container;
                        this.thirdLine = "Proceed To " + "<a class='greenFont'>" + this.firstIncompleteStage.toUpperCase() + "</a>";
                      }
                    }
                  }
                  if (this.gateTrans.findIndex(pp => pp.transaction_type.substring(0, 1) == "D") == -1) {
                    foundOneForSlotting = true;
                  }
                }

                if (dd.transaction_type == "DM") {
                  if (dd.yard_completed == null) {
                    foundOneForSlotting = true;
                  } else {
                    foundOneForSlotting = false;
                  }
                  if ((!addedRecord && this.deliverCount == 1) ) { //first DM in - ONLY DM single move  **late edition - deliverHeap part was added after testing was completed
                    this.gotoMessage = this.fixGroundedLocation(dd.ctr_pos_slot);
                    this.secondLine = "Get " + dd.container_iso_description;
                    this.thirdLine = "Proceed To " + "<a class='greenFont'>" + this.firstIncompleteStage.toUpperCase() + "</a>";
                  } else {
                    if (addedRecord && previousRec.ctr_pos_slot == dd.ctr_pos_slot) {// same location
                      if (previousRec.transaction_type == "DM") {
                        var prefix = "";
                        if (this.gateTrans.findIndex(pp => pp.transaction_type == "RM") != -1) {//was there a RM before
                          prefix = "Stay In " + "<a class='greenFont'>" + this.fixGroundedLocation(dd.ctr_pos_slot) + "</a>";
                        } else {
                          this.gotoMessage = this.fixGroundedLocation(dd.ctr_pos_slot);
                        }
                        if (previousRec.container_iso_description == dd.container_iso_description) {
                          var totalNum = this.gateTrans.filter(yy => yy.transaction_type == "DM" && yy.container_iso_code == dd.container_iso_code && yy.exchange_area_id == null)
                          this.secondLineNAHalf2 = prefix + " Get  (" + totalNum.length + ") " + dd.container_iso_description + " Containers";
                        } else {
                          this.secondLineNAHalf2 = prefix + " Get " + previousRec.container_iso_description + " and " + dd.container_iso_description;
                        }
                        this.thirdLine = "Proceed To " + "<a class='greenFont'>" + this.firstIncompleteStage.toUpperCase() + "</a>";
                      } else {
                        this.secondLineNAHalf2 = "Stay in " + "<a class='greenFont'>" + this.fixGroundedLocation(dd.ctr_pos_slot) + "</a>" + " Get " + dd.container_iso_description;
                        this.thirdLine = "Proceed To " + "<a class='greenFont'>" + this.firstIncompleteStage.toUpperCase() + "</a>";
                      }
                    } else { //different locations
                      if (addedRecord) {
                        var prefix = "";
                        if (this.gateTrans.findIndex(pp => pp.transaction_type == "RM") != -1) {//was there a RM before
                          prefix = "Go To " + "<a class='greenFont'>" + this.fixGroundedLocation(dd.ctr_pos_slot) + "</a>"
                        } else {
                          if (previousRec.transaction_type == "DM") {// was there a DM before
                            this.gotoMessage = this.fixGroundedLocation(previousRec.ctr_pos_slot);
                            this.secondLineNAHalf = prefix + " Get " + previousRec.container_iso_description
                            this.secondLineNAHalf2 = "Then Go To " + "<a class='greenFont'>" + this.fixGroundedLocation(dd.ctr_pos_slot.toUpperCase())+ "</a>";
                          } else {
                            this.gotoMessage = this.fixGroundedLocation(dd.ctr_pos_slot);
                          }
                        }
                        this.secondLineNAHalf3 = prefix + " Get " + dd.container_iso_description;
                        this.thirdLine = "Proceed To " + "<a class='greenFont'>" + this.firstIncompleteStage.toUpperCase() + "</a>";
                      }else if ((this.gateTrans[this.gateTrans.length-1].transaction_type=='DI' || this.gateTrans[this.gateTrans.length-1].transaction_type=='DE')){
                        this.gotoMessage = this.fixGroundedLocation(dd.ctr_pos_slot);
                        this.secondLine = "Get " + dd.container_iso_description;
                      }
                    }
                  }
                }
                this.fourthLine = "DO NOT DRIVE BEHIND EMPTY EQUIPMENT";
              } else {
                this.gotoMessage = "Slot Booth";
              }


            }
          }
           previousRec = dd;
           addedRecord = true;

        }

      }
    }




    if (!foundOneForSlotting) {
      howMany = 0;
      if (this.next_stage_order >= 41 && this.truckVisitStatus == "OK") {
        this.gotoMessage = ""
        this.firstLinePreText = "Go to ";
        this.secondLine = ""
        this.secondLineNAHalf = "";
        this.secondLineNAHalf2 = "";
        this.secondLineNAHalf3 = "";
        this.thirdLine = "";
        this.fourthLine = "";
        if (this.next_stage_id=="Slot_Booth"){
            this.gotoMessage = this.firstIncompleteStage;
        }else{
          this.gotoMessage = this.next_stage_desc;
        }
        if (this.next_stage_id != null) {
          if (this.next_stage_id.toUpperCase() == "OB_TCIR" || this.next_stage_id.toUpperCase() == "OB_U_TCIR") {
            this.gateTrans.forEach(dd => {
              if (dd.temp_required_c != null) {
                if (howMany == 0) {
                  this.secondLine = dd.container + " Temp: " + dd.temp_required_c + "C / " + dd.temp_required_f + "F";
                } else {
                  this.thirdLine = dd.container + " Temp: " + dd.temp_required_c + "C / " + dd.temp_required_f + "F";
                }
                howMany++
              }
              if (dd.transaction_type == "DM") {
                if (dd.vent_setting != null) {
                  if (howMany == 0) {
                    this.secondLine = dd.container + " Vent Setting: " + dd.vent_setting;
                  } else {
                    this.thirdLine = dd.container + " Vent Setting: " + dd.vent_setting;
                  }
                  howMany++
                }
              }
            })
          }
        }
      }
    }
  }

 fixGroundedLocation(xhold: string): string {
   var xPos;
   if (xhold!=null && xhold.substring(0,1)=="G") {
     if (xhold.length > 4) {
       try {
         if (xhold.includes(".")){
           xhold = xhold.substring(0,xhold.lastIndexOf(".")-2);
           xhold = xhold.replace(".","");  //uncomment this for checking for periods
           xhold = xhold.replace(".",""); //uncomment this for checking for periods
         }else{
           xhold = xhold.substring(0, 5);
         }
         xhold = xhold.replace(".","");
         // @ts-ignore
       } catch (ee: any) {
       }
     } else {
       xhold = xhold.substring(0, 4);
     }
   }else if (xhold!=null){
     xPos = xhold.indexOf(".");
     if (xPos>0){
       xhold = xhold.substring(0,xPos);
     }
   }
   return xhold;
 }

/*  THIS IS THE CODE NEEDED FOR SLOT MESSAGING WHEN EMPTIES HAVE A LIFT TIME AND GET RID OF EMPTY TIMER
  if (this.gateTrans != null && this.gateTrans.length > 0) {
  for (var dd of this.gateTrans) {
  if (dd.transaction_status!='CANCEL') {
  if (dd.exchange_area_id != null) {
  if (dd.yard_completed == null || (dd.strad_status!=null && dd.strad_status.toUpperCase()) == "PENDING") {
  foundOneForSlotting = true;
  if (dd.slot != null) {
  if (dd.stayInSlot) {
  this.firstLinePreText = "Stay in "
}
this.gotoMessage = "SLOT " + dd.slot;
if (dd.transaction_type.substring(0, 1) == "R") {
  this.secondLine = "Drop Container " + dd.container;
}
if (dd.transaction_type.substring(0, 1) == "D") {
  if (dd.transaction_type == "DI" && dd.group_code != null) {
    this.secondLine = "Get Container For Group " + dd.group_code;
  } else {
    this.secondLine = "Get Container " + dd.container;
  }
  this.thirdLine = "This is a " + dd.ctr_length + " container";
}
this.fourthLinePreText = "Straddle Status: ";
this.fourthLine = dd.strad_status;
} else {
  this.gotoMessage = "Slot Booth";
}
break;
}
} else {
  if (dd.transaction_type == "RM" || dd.transaction_type == "DM") {
    this.gotoMessage = dd.ctr_pos_slot;
    if (dd.transaction_type == "DM") {
      this.secondLine = "Get " + dd.container_iso_description;
    }else{
      this.secondLine = "Drop " + dd.container;

    }
    this.thirdLine = "This is a " + dd.ctr_length + " container";
    this.fourthLine = "DO NOT DRIVE BEHIND EMPTY EQUIPMENT";
  } else {
    this.gotoMessage = "Slot Booth";
  }
  break
}
}

}
}


 */

}
